<!--
create by melody on 2018/11/1
description:外围系统映射配置页面
-->

<template>
	<div>
		<template v-if = "!isShowEdit">
			<page-header :title="title"></page-header>
			<div class="search-container hdp-w-100">
				<div class="hdp-uf hdp-w-100">
					<div class="hdp-uf hdp-uf-vc">{{$t('m.outsideMapName')}}：</div>
					<el-input v-model.trim="searchParam.keyName" style="width:25%;margin-left:10px;margin-right:5%;" clearable></el-input>
					<!-- <el-button type="primary" icon="el-icon-search" style="margin-left:5%;" @click="getDemoList()"> 查 询</el-button> -->
					<lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
				</div>
			</div>
			<div class="table-container" ref="tableContainer">
				<el-button type="primary" icon="el-icon-plus" plain @click="handleClick('add')"> {{$t('m.add')}} </el-button>
				<el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
				<el-table
					:data="tableData"
					stripe
					tooltip-effect="dark"
					style="width: 100%;margin: 24px 0"
					@select="handleSelect" 
					@select-all="handleSelect"
					>
					<el-table-column
						type="selection"
						width="35">
					</el-table-column>
					<el-table-column
						type="index"
						label="#">
					</el-table-column>
					<el-table-column
						:label="$t('m.outsideMapName')">
						<template  slot-scope="scope">
                            <span class="span-style" @click="handleEdit(scope.row.outsideMapId,scope.row.outsideMapCode)">{{scope.row.outsideMapName}}</span>
                        </template>
					</el-table-column>
					<el-table-column
						prop="outsideMapCode"
						:label="$t('m.outsideMapCode')">
					</el-table-column>
					<el-table-column
						prop="createTime"
						:label="$t('m.createTime')">
					</el-table-column>
					<el-table-column
						:label="$t('m.operation')"
						align="right" width="150">
						<template slot-scope="scope">
							<!-- <el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modify', scope.row)"></el-button> -->
							<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single', scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
			</div>
		</template>
		<template v-else = "isShowEdit">
			<page-header :title="title"></page-header>
			<div class="table-container">
				<p>
					<el-button type="text" icon="el-icon-arrow-left" @click="isShowEdit = false">{{$t('m.back')}}</el-button>
				</p>
				<div class="" style="margin-top:30px;">
					<el-button type="primary" icon="el-icon-plus" size="small" plain @click="handleClick2('add')"> {{$t('m.addLine')}} </el-button>
					<el-button type="info" icon="el-icon-delete" size="small" plain @click="handleDelete2('batch')"> {{$t('m.deleteLine')}} </el-button>
					<el-button type="primary" icon="el-icon-plus" size="small" plain style="margin-left:30px;" @click="handleColumn('addInput')"> {{$t('m.addInputColumn')}} </el-button>
					<el-button type="info" icon="el-icon-delete" size="small" plain @click="handleColumn('deleteInput')"> {{$t('m.deleteInputColumn')}} </el-button>
					<el-button type="primary" icon="el-icon-plus" size="small" plain style="margin-left:30px;" @click="handleColumn('addMap')"> {{$t('m.addMapColumn')}} </el-button>
					<el-button type="info" icon="el-icon-delete" size="small" plain @click="handleColumn('deleteMap')"> {{$t('m.deleteMapColumn')}} </el-button>
				</div>
				<div class="hdp-uf psc-bg-info2 psc-font-4" style="margin-top:24px;padding:10px;">{{systemMappingName}}</div>
				<el-table
					:data="tableData2"
					stripe
					tooltip-effect="dark"
					style="margin: 24px 0"
					@select="handleSelect2" 
					@select-all="handleSelect2"
					:header-cell-style="cellStyle"
					:cell-style="cellStyle"
					>
					<el-table-column>
						<el-table-column
							type="selection"
							width="35">
						</el-table-column>
						<el-table-column
							type="index"
							label="#">
						</el-table-column>
					</el-table-column>
					<el-table-column
						:label="$t('m.inputValue')">
						<el-table-column
							v-for="(item, index) in tableInputList"
							:key="index"
							:prop="item.prop"
							:label="item.label"
							width="150">
						</el-table-column>
					</el-table-column>
					<el-table-column
						:label="$t('m.mapValue')">
						<el-table-column
							v-for="(item, index) in tableMapList"
							:key="index"
							:prop="item.prop"
							:label="item.label"
							width="150">
						</el-table-column>
					</el-table-column>
					<el-table-column>
						<el-table-column
							:label="$t('m.operation')"
							fixed="right"
							align="right" width="150">
							<template slot-scope="scope">
								<el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick2('modify', scope.row)"></el-button>
								<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete2('single', scope.row)"></el-button>
							</template>
						</el-table-column>
					</el-table-column>
				</el-table>
				<lap-pagination :total="total2" :searchParam="searchParam2" @successMethod="getDemoList2()"></lap-pagination>
			</div>
		</template>
		<!-- add inputValueColumn Form -->
		<el-dialog :title="operateType == 'add' ? $t('m.add') : $t('m.modify')" :visible.sync="dialogVisible" v-if="dialogVisible" width="50%">
			<div style="margin-left: 10%">
				<el-form ref="form" :model="form" :rules="rules" label-width="140px">
					<el-form-item  :label="$t('m.outsideMapName')" prop="outsideMapCode">
						<!-- <el-input :disabled="operateType=='modify'" v-model.trim="form.outsideMapName" :maxlength="$inputLengthObj.maxLength3" placeholder="请输入内容" style="width:80%;"></el-input> -->
						<el-select :disabled="operateType=='modify'" v-model.trim="form.outsideMapCode" style="width:80%;">
							<el-option v-for="(item,index) in mapNameList" :key="index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="operateType == 'add'"  :label="$t('m.inputColumn')" >
						<el-checkbox-group v-model="form.checkedInputs">
		                    <el-checkbox v-for="(item,index) in tableInputList" :label="item.prop" :key="index">{{item.label}}
		                    </el-checkbox>
		                </el-checkbox-group>
					</el-form-item>
					<el-form-item v-if="operateType == 'add'" :label="$t('m.mapColumn')">
						<el-checkbox-group v-model="form.checkedMaps">
		                    <el-checkbox v-for="(item,index) in tableMapList" :label="item.prop" :key="index">{{item.label}}
		                    </el-checkbox>
		                </el-checkbox-group>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
		<!-- add inputValueColumn Form -->
		<el-dialog 
			:title="handleColumnType=='addInput' ? $t('m.addInputColumn') : handleColumnType=='deleteInput'? $t('m.deleteInputColumn') : handleColumnType=='addMap' ? $t('m.addMapColumn'):$t('m.deleteMapColumn')" 
			:visible.sync="dialogColumnVisible"
			width="30%">
			<div style="margin-left: 10%">
				<el-form>
					<el-form-item v-if="handleColumnType=='addInput'" :label="$t('m.inputColumn')">
						<el-select v-model="columnValue" style="width:50%;">
							<el-option v-for="(item,index) in tableInputList" v-if="!item.isShow" :key="index" :label="item.label" :value="item.prop"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-else-if="handleColumnType=='deleteInput'" :label="$t('m.inputColumn')">
						<el-select v-model="columnValue" style="width:50%;">
							<el-option v-for="(item,index) in tableInputList" v-if="item.isShow" :key="index" :label="item.label" :value="item.prop"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-else-if="handleColumnType=='addMap'" :label="$t('m.mapColumn')">
						<el-select v-model="columnValue" style="width:50%;">
							<el-option v-for="(item,index) in tableMapList" v-if="!item.isShow" :key="index" :label="item.label" :value="item.prop"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-else="handleColumnType=='deleteMap'" :label="$t('m.mapColumn')">
						<el-select v-model="columnValue" style="width:50%;">
							<el-option v-for="(item,index) in tableMapList" v-if="item.isShow" :key="index" :label="item.label" :value="item.prop"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogColumnVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" @click="modifyDemo1(handleColumnType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
		<!-- add inputValueColumn Form -->
		<el-dialog 
			:title="operateType2 == 'add' ? $t('m.add') : $t('m.modify')" 
			:visible.sync="dialogVisible2" 
			v-if="dialogVisible2" 
			width="30%">
			<div class="dialog-max-height">
				<el-form ref="form2" :model="form2" :rules="rules2">
					<div class="title-style">{{$t('m.inputValue')}}</div>
					<el-form-item v-for="(item, index) in tableInputList" v-if="item.isShow" :key="index + '0'" :label="item.label" :prop="item.prop" label-width="140px">
						<el-select v-if="item.type=='select'" v-model="form2[item.prop]" style="width:80%;">
							<el-option v-for="(item2,index2) in item.list" :key="index2 + '' + index" :label="item2.label" :value="item2.label"></el-option>
						</el-select>
						<el-input v-else v-model.trim="form2[item.prop]" :maxlength="item.length" style="width:80%;"></el-input>
					</el-form-item>
					<div class="title-style">{{$t('m.mapValue')}}</div>
					<el-form-item v-for="(item, index) in tableMapList" v-if="item.isShow" :key="index + '1'" :label="item.label" :prop="item.prop" label-width="140px">
						<el-select v-if="item.type=='select'" v-model="form2[item.prop]" style="width:80%;">
							<el-option v-for="(item2,index2) in item.list" :key="index2 + '' + index" :label="item2.label" :value="item2.label"></el-option>
						</el-select>
						<el-input v-else v-model.trim="form2[item.prop]" :maxlength="item.length" style="width:80%;"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2 = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave2(operateType2)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.SYSTEM_MAPPING')
			},
			isShowEdit:false,
			columnValue: '',
			searchParam: {
				keyName:'',
				pageNum: 1,
				pageSize: 10
			},
			searchParam2: {
				outsideMapId:'',
				pageNum: 1,
				pageSize: 10
			},
			form: {
				outsideMapName:'',
				outsideMapCode: '',
				checkedInputs: [],
            	checkedMaps: [],
				// enableFlag: true
			},
			form2: {},
            rules: this.$ruleApi.getRule('systemMapping'),
            rules2: this.$ruleApi.getRule('systemMappingLine'),
            tableData: [],  //表数据
            tableData2: [],
            systemMappingName: '',
           	tableInputList: [
				{
					label: this.$t('m.primaryLedger'),
					prop: 'primaryLedgerInput',
				},
				{
					label: this.$t('m.ouName'),
					prop: 'ouNameInput',
				},
				{
					label: this.$t('m.costCenter'),
					prop: 'costCenterInput',
				},
				{
					label: this.$t('m.currency'),
					prop: 'currencyInput',
				},
				{
					label: this.$t('m.leaseType'),
					prop: 'leaseTypeInput',
				},
				{
					label: this.$t('m.dataSource'),
					prop: 'dataSourceInput',
				},
				{
					label: this.$t('m.region'),
					prop: 'regionInput',
				},
				{
					label: this.$t('m.leaseItemCategory'),
					prop: 'itemInfoInput',
				},
				{
					label: this.$t('m.leaseTerm'),
					prop: 'leaseTermInput',
				},
				{
					label: this.$t('m.leaseItemType'),
					prop: 'leaseItemTypeInput',
				},
				{
					label: this.$t('m.usefulLife'),
					prop: 'usefulLifeInput',
				}],
				tableMapList: [
				{
					label: this.$t('m.primaryLedger'),
					prop: 'primaryLedgerMap',
				},
				{
					label: this.$t('m.ouName'),
					prop: 'ouNameMap',
				},
				{
					label: this.$t('m.costCenter'),
					prop: 'costCenterMap',
				},
				{
					label: this.$t('m.currency'),
					prop: 'currencyMap',
				},
				{
					label: this.$t('m.leaseType'),
					prop: 'leaseTypeMap',
				},
				{
					label: this.$t('m.dataSource'),
					prop: 'dataSourceMap',
				},
				{
					label: this.$t('m.region'),
					prop: 'regionMap',
				},
				{
					label: this.$t('m.leaseItemCategory'),
					prop: 'itemInfoMap',
				},
				{
					label: this.$t('m.leaseTerm'),
					prop: 'leaseTermMap',
				},
				{
					label: this.$t('m.leaseItemType'),
					prop: 'leaseItemTypeMap',
				},
				{
					label: this.$t('m.usefulLife'),
					prop: 'usefulLifeMap',
				},
				{
					label: this.$t('m.assetBook'),
					prop: 'assetBook',
				},
				{
					label: this.$t('m.assetCategory'),
					prop: 'assetCategory',
				},
				{
					label: this.$t('m.depreciationExpenseAccount'),
					prop: 'depreciationExpenseAccount'
				},
                    {
                        label: this.$t('m.assetCostCoa'),
                        prop: 'assetCostCoa'
                    },

                    {
                        label: this.$t('m.depreciationCoa'),
                        prop: 'depreciationCoa'
                    },

                ],
            total: 0,   //总数
            total2: 0,
            dialogVisible: false,   //控制弹框显示与隐藏
            dialogVisible2: false,
			dialogColumnVisible: false,
            operateType:'',
			operateType2:'',
			handleColumnType: '', 
			deleteDemoIdArr: [],
			deleteDemoIdArr2: [],
			systemMappingIdFlag: '',
			systemMappingCodeFlag: '',
			mapNameList: [],//映射名称
			accountList:[], //主账套
			busEntityList: [],		//公司主体
			costCenterList: [],  	//成本中心
			currencyList: [],		//本位币
			leaseTypeList: [],		//租赁类型
			dataSourceList: [],		//数据来源
            regionList: [],			//国家或地区
            leaseItemTypeList: [],		//租赁物件类型
            hasSelectListFlag: false,
            addDisable: false
		}
	},
	methods: {
		cellStyle({row, column, rowIndex, columnIndex}){ 
			let style = ''
			this.tableInputList.forEach((o,i)=>{
				if(column.property == o.prop && !o.isShow) {
					style = 'background:#ccc'
				}
			})
			this.tableMapList.forEach((o,i)=>{
				if(column.property == o.prop && !o.isShow) {
					style = 'background:#ccc'
				}
			})
			return style 
        },		
        handleColumn(type) {
			this.columnValue = ''
			this.handleColumnType = type
			this.dialogColumnVisible = true
		},
		async handleEdit(outsideMapId,outsideMapCode) {
			if(!this.hasSelectListFlag) {
				this.accountList = await this.$commonFunc.getValueSetList(this.$valueSetObj.MAIN_ACCOUNT) 
				this.busEntityList = await this.$commonFunc.getValueSetList(this.$valueSetObj.BUSINESS_ENTITY) 
				this.costCenterList = await this.$commonFunc.getValueSetList(this.$valueSetObj.COST_CENTER) 
				this.currencyList = await this.$commonFunc.getValueSetList(this.$valueSetObj.CURRENCY)
				this.leaseTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj.LEASE_TYPE)
				this.dataSourceList = await this.$commonFunc.getValueSetList(this.$valueSetObj.SOURCE)
		        this.regionList = await this.$commonFunc.getValueSetList(this.$valueSetObj.REGION)
		        this.leaseItemTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj.LEASE_ITEM_TYPE)
		        this.hasSelectListFlag = true
			}
			this.systemMappingIdFlag = outsideMapId
			this.systemMappingCodeFlag = outsideMapCode
			this.$commonFunc.commonRequest('get', '/config/outside_map/outsideMapId', 'getSystemMappingColumn', {outsideMapId: outsideMapId})
            .then(res=>{
                let row = res.obj
                this.systemMappingName = row.outsideMapName
                this.accountList
                this.busEntityList
     			this.tableInputList = [
				{
					label: this.$t('m.primaryLedger'),
					prop: 'primaryLedgerInput',
					isShow: row.primaryLedgerInput,
					type: 'select',
					list: this.accountList
				},
				{
					label: this.$t('m.ouName'),
					prop: 'ouNameInput',
					isShow: row.ouNameInput,
					type: 'select',
					list: this.busEntityList
				},
				{
					label: this.$t('m.costCenter'),
					prop: 'costCenterInput',
					isShow: row.costCenterInput,
					type: 'select',
					list: this.costCenterList
				},
				{
					label: this.$t('m.currency'),
					prop: 'currencyInput',
					isShow: row.currencyInput,
					type: 'select',
					list: this.currencyList
				},
				{
					label: this.$t('m.leaseType'),
					prop: 'leaseTypeInput',
					isShow: row.leaseTypeInput,
					type: 'select',
					list: this.leaseTypeList
				},
				{
					label: this.$t('m.dataSource'),
					prop: 'dataSourceInput',
					isShow: row.dataSourceInput,
					type: 'select',
					list: this.dataSourceList
				},
				{
					label: this.$t('m.region'),
					prop: 'regionInput',
					isShow: row.regionInput,
					type: 'select',
					list: this.regionList
				},
				{
					label: this.$t('m.leaseItemCategory'),
					prop: 'itemInfoInput',
					isShow: row.itemInfoInput,
					type: 'input',
					length: this.$inputLengthObj.maxLength1
				},
				{
					label: this.$t('m.leaseTerm'),
					prop: 'leaseTermInput',
					isShow: row.leaseTermInput,
					type: 'input',
					length: this.$inputLengthObj.maxLength6
				},
				{
					label: this.$t('m.leaseItemType'),
					prop: 'leaseItemTypeInput',
					isShow: row.leaseItemTypeInput,
					type: 'select',
					list: this.leaseItemTypeList
				},
				{
					label: this.$t('m.usefulLife'),
					prop: 'usefulLifeInput',
					isShow: row.usefulLifeInput,
					type: 'input',
					length: this.$inputLengthObj.maxLength6
				},]
				this.tableMapList = [
				{
					label: this.$t('m.primaryLedger'),
					prop: 'primaryLedgerMap',
					isShow: row.primaryLedgerMap,
					type: 'select',
					list: this.accountList
				},
				{
					label: this.$t('m.ouName'),
					prop: 'ouNameMap',
					isShow: row.ouNameMap,
					type: 'select',
					list: this.busEntityList
				},
				{
					label: this.$t('m.costCenter'),
					prop: 'costCenterMap',
					isShow: row.costCenterMap,
					type: 'select',
					list: this.costCenterList
				},
				{
					label: this.$t('m.currency'),
					prop: 'currencyMap',
					isShow: row.currencyMap,
					type: 'select',
					list: this.currencyList
				},
				{
					label: this.$t('m.leaseType'),
					prop: 'leaseTypeMap',
					isShow: row.leaseTypeMap,
					type: 'select',
					list: this.leaseTypeList
				},
				{
					label: this.$t('m.dataSource'),
					prop: 'dataSourceMap',
					isShow: row.dataSourceMap,
					type: 'select',
					list: this.dataSourceList
				},
				{
					label: this.$t('m.region'),
					prop: 'regionMap',
					isShow: row.regionMap,
					type: 'select',
					list: this.regionList
				},
				{
					label: this.$t('m.leaseItemCategory'),
					prop: 'itemInfoMap',
					isShow: row.itemInfoMap,
					type: 'input',
					length: this.$inputLengthObj.maxLength1
				},
				{
					label: this.$t('m.leaseTerm'),
					prop: 'leaseTermMap',
					isShow: row.leaseTermMap,
					type: 'input',
					length: this.$inputLengthObj.maxLength6
				},
				{
					label: this.$t('m.leaseItemType'),
					prop: 'leaseItemTypeMap',
					isShow: row.leaseItemTypeMap,
					type: 'select',
					list: this.leaseItemTypeList
				},
				{
					label: this.$t('m.usefulLife'),
					prop: 'usefulLifeMap',
					isShow: row.usefulLifeMap,
					type: 'input',
					length: this.$inputLengthObj.maxLength3
				},
				{
					label: this.$t('m.assetBook'),
					prop: 'assetBook',
					isShow: row.assetBook,
					type: 'input',
					length: this.$inputLengthObj.maxLength3
				},
				{
					label: this.$t('m.assetCategory'),
					prop: 'assetCategory',
					isShow: row.assetCategory,
					type: 'input',
					length: this.$inputLengthObj.maxLength3
				},
				{
					label: this.$t('m.depreciationExpenseAccount'),
					prop: 'depreciationExpenseAccount',
					isShow: row.depreciationExpenseAccount,
					type: 'input',
					length: this.$inputLengthObj.maxLength3
				},
                    {
                        label: this.$t('m.assetCostCoa'),
                        prop: 'assetCostCoa',
                        isShow: row.assetCostCoa,
                        type: 'input',
                        length: this.$inputLengthObj.maxLength3
                    },
                    {
                        label: this.$t('m.depreciationCoa'),
                        prop: 'depreciationCoa',
                        isShow: row.depreciationCoa,
                        type: 'input',
                        length: this.$inputLengthObj.maxLength3
                    }

                ]
				this.isShowEdit = true
				this.searchParam2.outsideMapId = outsideMapId
				this.getDemoList2()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })	
		},
		getDemoList() {
            this.$commonFunc.commonRequest('get', '/config/outside_map/list/condition', 'getSystemMappingList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
        	this.mapNameList.forEach(o=>{
        		if(o.value == this.form["outsideMapCode"]) {
        			this.form["outsideMapName"] = o.label
        		}
        	})
            this.$commonFunc.commonRequest('post', '/config/outside_map/added', 'addSystemMapping', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/config/outside_map/modified', 'modifySystemMapping', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
       	modifyDemo1(type) {
        	if(!this.columnValue) {
        		this.$message.info(this.$t('m.pleaseChoose'))
        		return
        	}
        	let a = this.columnValue
        	let obj = {}
        	obj['outsideMapId'] = this.systemMappingIdFlag
        	if(type == 'addInput' || type == 'addMap') {
        		obj[a] = true
        	} else {
        		obj[a] = false
        	}
        	console.log('add obj: %s',JSON.stringify(obj))
            this.$commonFunc.commonRequest('post', '/config/outside_map/modified', 'modifySystemMappingCol', obj)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogColumnVisible = false
                this.handleEdit(this.systemMappingIdFlag)
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
           	this.dialogVisible = true
            //如果操作已有数据
            if(row) {
            	this.form = JSON.parse(JSON.stringify(row))
            } else {
                this.form = {
	                outsideMapName: '',
	                outsideMapCode: '',
	                checkedInputs: [],
	                checkedMaps: [],
					// enableFlag: true
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                    	this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
        	if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.outsideMapId)
                } else {
                	demoIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('get', '/config/outside_map/deleted', 'deleteSystemMapping', {outsideMapIds: demoIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'));
                	this.deleteDemoIdArr = []
                	this.getDemoList()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
		handleCurrentChange(val) {
            this.searchParam.pageNum = val
            this.getDemoList()
        },
        handleSizeChange(val) {
            this.searchParam.pageSize = val
            this.getDemoList()
        },
		//处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].outsideMapId)
                }
            }
        },
        //映射行
        getDemoList2() {
            this.$commonFunc.commonRequest('get', '/config/outside_map_line/list/outsideMapId', 'getSystemMappingLineList', this.searchParam2)
            .then(res=>{
                this.tableData2 = res.obj.list
                this.total2 = res.obj.total
                // console.log('table: %s', JSON.stringify(this.tableData2))
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo2() {
        	this.form2.outsideMapId = this.systemMappingIdFlag
        	this.form2.outsideMapCode = this.systemMappingCodeFlag
            this.$commonFunc.commonRequest('post', '/config/outside_map_line/added', 'addSystemMappingLine', this.form2)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible2 = false
                this.getDemoList2()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo2() {
        	this.form2.outsideMapId = this.systemMappingIdFlag
        	this.form2.outsideMapCode = this.systemMappingCodeFlag
            this.$commonFunc.commonRequest('post', '/config/outside_map_line/modified', 'modifySystemMappingLine', this.form2)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible2 = false
                this.getDemoList2()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick2(type,row) {
            this.operateType2 = type
           	this.dialogVisible2 = true
            //如果操作已有数据
            if(row) {
            	this.form2 = JSON.parse(JSON.stringify(row))
            } else {
                this.form2 = {
                	// enableFlag: true
                }
            }
        },
        //弹框保存操作
        haddleSave2(type) {
        	let allEmpty = false
        	this.tableInputList.forEach((o,i)=>{
        		if(this.form2[o.prop]) {
        			allEmpty = true
        		}
        	})
        	this.tableMapList.forEach((o,i)=>{
        		if(this.form2[o.prop]) {
        			allEmpty = true
        		}
        	})
        	if(!allEmpty) {
        		this.$message.info(this.$t('m.noData'))
        		return
        	}
            this.$refs['form2'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                    	this.addDisable = true
                        this.addDemo2()
                    } else {
                        this.modifyDemo2()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete2(type,row) {
        	if( type == 'batch' && this.deleteDemoIdArr2.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.outsideMapLineId)
                } else {
                	demoIds = this.deleteDemoIdArr2
                }
                this.$commonFunc.commonRequest('get', '/config/outside_map_line/deleted', 'deleteSystemMappingLine', {outsideMapLineIds: demoIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'));
                	this.deleteDemoIdArr2 = []
                	this.getDemoList2()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
		handleCurrentChange2(val) {
            this.searchParam2.pageNum = val
            this.getDemoList2()
        },
        handleSizeChange2(val) {
            this.searchParam2.pageSize = val
            this.getDemoList2()
        },
		//处理单选
        handleSelect2(row) {
            this.deleteDemoIdArr2 = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr2.push(row[i].outsideMapLineId)
                }
            }
        },
	},
	async mounted() {
		this.mapNameList = await this.$commonFunc.getValueSetList(this.$valueSetObj.MAPPING_NAME, true)
		this.getDemoList()
	}
}
</script>
<style scoped>
.search-container {
	background: #ffffff;
	padding: 20px;
}
.el-select {
	width: 300px;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.block {
	text-align: right;
}
.span-style {
    color: #409EFF;
    cursor: pointer;
}
.title-style  {
	color: #409EFF;
	line-height: 40px;
	font-size: 16px;
}
.el-checkbox {
    margin-right: 30px;
}
.el-checkbox+.el-checkbox {
    margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/SystemMapping.vue